import React, { useMemo, useCallback, useState, useEffect } from 'react';

import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  IconButton,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { concat, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

export default function Search({ options, onSearch, activeFilter }) {
  const [column, setColumn] = useState('');
  const [text, setText] = useState('');


  const renderOptions = useMemo(
    () =>
      options.map((option, key) => (
        <MenuItem key={`options-${key}`} value={option.id}>
          {option.label}
        </MenuItem>
      )),
    [options]
  );

  const handleChangeSelect = useCallback((value) => {
    setColumn(value);
  }, []);

  const handleChangeText = useCallback((value) => {
    setText(value);
  }, []);

  const handleSubmit = useCallback(() => {
    onSearch({ column, text });
  }, [column, text]);

  useEffect(() => {
    if (!isEmpty(options)) setColumn(concat([], options).shift().id);
  }, [options]);

  return (
    <S.Wrapper>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        label={t('s.geral.pesquisar')}
        value={text}
        onChange={({ target }) => handleChangeText(target.value)}
        onKeyPress={({ key }) => key === 'Enter' && handleSubmit()}
      />

      {options.length > 0 && (
        <FormControl size="small" variant="outlined" fullWidth>
          <Select
          size="small"
            value={column}
            onChange={({ target }) => handleChangeSelect(target.value)}
          >
            {renderOptions}
          </Select>
        </FormControl>
      )}

      <IconButton color="primary" onClick={handleSubmit}>
        <SearchIcon color={activeFilter} />
      </IconButton>
    </S.Wrapper>
  );
}

Search.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  onSearch: PropTypes.func.isRequired,
};
